import { Component, ElementRef, EventEmitter, inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Input } from '@angular/core';
import { decompress } from 'lz-string';
import { StoreService } from 'src/app/services/store.service';
import { RallyanceReclamationNewReclamationFormValues, RallyanceReclamationReasons, ReclamationReasonsResponse } from 'src/app/Interfaces/reclamations';
import { ReclamationService } from 'src/app/services/reclamation.service';
import { map, Subject, take } from 'rxjs';

@Component({
	selector: 'app-reclamation-popup-content',
	templateUrl: './reclamation-popup-content.component.html',
	styleUrls: ['./reclamation-popup-content.component.scss'],
})
export class ReclamationPopupContentComponent implements OnInit, OnDestroy {
	@Input() product: any;
	@Input() CustImageDomain: string;
	@Input() DoctypeName: string;
	@Output() readonly submitted = new EventEmitter<RallyanceReclamationNewReclamationFormValues>();

	private fb = inject(FormBuilder);
	private _reclamation = inject(ReclamationService);
	constructor() {}

	isBarcodePopupOpen = false;
	supportsVideo = true;
	@ViewChild('videoElement') videoElement: ElementRef<HTMLVideoElement>;
	video: HTMLVideoElement;
	mediaStream: MediaStream;
	detectedCode = '';
	intervalID;

	reclamationReasons: RallyanceReclamationReasons[] = [];

	reclamationReasons$ = this._reclamation.sugRecReasons$.pipe(map((reasons: RallyanceReclamationReasons[]) => reasons.filter(reason => reason.Sug === '1')));

	form = this.fb.nonNullable.group({
		RekID: ['', [Validators.required]],
		SugTakala: ['', [Validators.required]],
		AgentRemark: ['', [Validators.maxLength(200)]],
		DOT: ['', [Validators.maxLength(100)]],
	});

	destroy$ = new Subject<void>();

	ngOnInit(): void {
		this._reclamation.init();

		if (!this._reclamation.sugRecReasons$.value.length) {
			alert('יש לעדכן נתונים בכדי לבצע רקלמציה');
			history.back();
			return;
		}

		this.reclamationReasons$.pipe(take(1)).subscribe((reasons: RallyanceReclamationReasons[]) => {
			this.reclamationReasons = reasons;
		});
	}

	submit() {
		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return;
		}
		const values = { ...this.form.value, SugTakala: this.reclamationReasons.find(x => +x.ID === +this.form.value.SugTakala).Name } as RallyanceReclamationNewReclamationFormValues;
		this.submitted.emit(values);
	}

	handleBarcodePopupOpen(clickEvent: Event) {
		clickEvent.stopPropagation();

		this.isBarcodePopupOpen = true;

		setTimeout(() => {
			try {
				if (this.videoElement && this.videoElement.nativeElement) {
					this.video = this.videoElement.nativeElement;
				} else {
					alert('no video element');
					throw new Error();
				}

				if (!window.BarcodeDetector) {
					alert('קורא ברקוד אינו נתמך במכשיר זה');
					throw new Error();
				}

				if (!window.navigator.mediaDevices || !('getUserMedia' in window.navigator.mediaDevices)) {
					alert('אין גישה למצלמה');
					throw new Error();
				}
			} catch (error) {
				this.handleBarcodePopupClose();
				return;
			}

			const constraints: MediaStreamConstraints = {
				video: { facingMode: { exact: 'environment' } },
				audio: false,
			};

			window.navigator.mediaDevices
				.getUserMedia(constraints)
				.then(async stream => {
					this.video.srcObject = stream;
					this.video.play();

					this.mediaStream = stream;
					const formats: SupportedFormats[] = ['code_39', 'codabar', 'ean_13', 'code_128'];

					const barcodeFormatsDetect = new window.BarcodeDetector({ formats });

					if (!barcodeFormatsDetect) {
						alert('קורא ברקוד אינו נתמך במכשיר זה');
						return;
					}

					const barcodeDetector = new window.BarcodeDetector({ formats });

					// Detect code function
					const detectCode = async () => {
						if (!('detect' in barcodeDetector) || !this.video || this.video.paused) {
							return;
						}

						if (this.detectedCode?.length) {
							return;
						}

						try {
							const codes = await barcodeDetector.detect(this.video);
							if (!codes?.length) return;

							for (const barcode of codes) {
								this.detectedCode = barcode.rawValue;

								// const searchControl = this.isConcentratedProductPopupShowing$.value ? this.concentratedProductsForm.controls.concentratedProductsSearch : this.form.controls.ProductSearch;

								this.form.controls.RekID.setValue(barcode.rawValue);
							}
							// this.SearchProducts();
						} catch (error) {
							console.error(error);
						}

						this.handleBarcodePopupClose();
					};

					this.intervalID = setInterval(detectCode, 200);
				})
				.catch(err => {
					this.supportsVideo = false;
					alert('יש לאפשר גישה למצלמה כדי להפעיל סורק ברקוד');
					this.handleBarcodePopupClose();
				});
		}, 0);
	}

	handleBarcodePopupClose() {
		if (this.mediaStream) {
			for (const track of this.mediaStream.getTracks()) {
				this.mediaStream.removeTrack(track);
			}
		}
		if (this.video) {
			this.video.srcObject = null;
			this.video.pause();
		}

		clearInterval(this.intervalID);

		this.detectedCode = '';

		this.isBarcodePopupOpen = false;
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();

		this.handleBarcodePopupClose();
	}
}
